import { NavMenu } from "components/navigation/nav-menu";
import React from "react";
import { useFeature } from "store/selectors/hooks";

export const TasksNavigation: React.FC<unknown> = () => {
    const entitiesWithoutActiveTasksEnabled = useFeature("entitiesWithoutActiveTasks");

    // If the feature is off, don't show navigation since there's only one link
    // and the site-wide nav already goes to /tasks
    if (!entitiesWithoutActiveTasksEnabled) {
        return null;
    }

    const links = [
        {
            to: "/tasks",
            label: "Active Tasks",
            exact: true,
        },
        {
            to: "/tasks/missing",
            label: "No Next Steps",
            exact: true,
        },
    ];

    return <NavMenu links={links} />;
};
